import { render, staticRenderFns } from "./FirmConfigurableDocumentsForm.vue?vue&type=template&id=e35b668c"
import script from "./FirmConfigurableDocumentsForm.vue?vue&type=script&lang=js"
export * from "./FirmConfigurableDocumentsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports